import {ChangeDetectionStrategy, Component, inject, input, InputSignal, output, OutputEmitterRef} from "@angular/core";
import {IconButtonComponent} from "../../buttons/icon-button/icon-button.component";
import {IconButtonType} from "../../buttons/icon-button/icon-button";
import {NgClass} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonShape} from '../../configuration/app-entity.model';
import {ConfigurationModel} from '../../configuration/configuration.model';

@Component({
    selector: "woa-quantity-control",
    templateUrl: "./quantity-control.component.html",
    styleUrl: "./quantity-control.component.scss",
    host: {
        "(click)": "$event.stopPropagation()"
    },
    imports: [
        IconButtonComponent,
        NgClass,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuantityControlComponent {
    public configurationModel: ConfigurationModel = inject(ConfigurationModel);

    public readonly decrementUnavailable: InputSignal<boolean> = input<boolean>(false);
    public readonly incrementUnavailable: InputSignal<boolean> = input<boolean>(false);
    public readonly decrementDisabled: InputSignal<boolean> = input<boolean>(false);
    public readonly incrementDisabled: InputSignal<boolean> = input<boolean>(false);
    public readonly minQuantity: InputSignal<number> = input<number>(0);
    public readonly maxQuantity: InputSignal<number> = input<number>(Number.MAX_SAFE_INTEGER);
    public readonly quantity: InputSignal<number> = input<number>(0);
    public readonly transparent: InputSignal<boolean> = input<boolean>(false);
    public readonly readOnly: InputSignal<boolean> = input<boolean>(false);

    public onDecrement: OutputEmitterRef<void> = output<void>();
    public onIncrement: OutputEmitterRef<void> = output<void>();

    IconButtonType = IconButtonType;
    ButtonShape = ButtonShape;

    decrement(): void {
        if (!(this.decrementDisabled() || this.quantity() <= this.minQuantity())) {
            this.onDecrement.emit();
        }
    }

    increment(): void {
        if (!(this.incrementDisabled() || this.quantity() >= this.maxQuantity())) {
            this.onIncrement.emit();
        }
    }
}
